// Segments (Figma "Segment"): Week / Month, Performance / Overview / Recovery.
// Arrow keys move between them, as a tab list.
import * as React from 'react';
import { cn } from '../../lib/utils';
import { FOCUS } from './Button';

export function SegmentedControl({ segments, value, onChange, fill = false, label, className }) {
  const refs = React.useRef([]);
  const onKeyDown = (e, i) => {
    const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
    if (!step) return;
    e.preventDefault();
    const next = (i + step + segments.length) % segments.length;
    refs.current[next]?.focus();
    onChange(segments[next].value);
  };
  return (
    <div role="tablist" aria-label={label}
      className={cn('inline-flex rounded-full border border-border-subtle bg-bg-surface p-1', fill && 'flex w-full', className)}>
      {segments.map((s, i) => {
        const on = s.value === value;
        return (
          <button key={s.value} ref={(el) => { refs.current[i] = el; }} type="button" role="tab"
            aria-selected={on} tabIndex={on ? 0 : -1}
            onClick={() => { if (!on) onChange(s.value); }} onKeyDown={(e) => onKeyDown(e, i)}
            className={cn('h-[34px] whitespace-nowrap rounded-full px-3 type-button-small transition-colors', FOCUS, fill && 'flex-1',
              on ? 'bg-border-default text-text-primary' : 'text-text-secondary hover:text-text-primary')}>
            {s.label}
          </button>
        );
      })}
    </div>
  );
}
